import { render, staticRenderFns } from "./TableForm2.vue?vue&type=template&id=6590c5e4&scoped=true"
import script from "./TableForm2.vue?vue&type=script&lang=ts"
export * from "./TableForm2.vue?vue&type=script&lang=ts"
import style0 from "./TableForm2.vue?vue&type=style&index=0&id=6590c5e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6590c5e4",
  null
  
)

export default component.exports